import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const SubsidiariesStyles = styled.div`
  .full-width-bg {
    background-color: ${Colors.accent.grey7.standard};
  }
  .area-header {
    padding: 50px 0 60px 0;
    margin-bottom: 45px;
  }
  .intro-p {
    margin-bottom: 45px;
  }
  .brand-blurb {
    margin-bottom: 30px;
  }
  .subsidiaries-listing {
    padding: 90px 0 30px 0;

    .subsidiaries-heading {
      margin-bottom: 24px;
    }
    p {
      margin-bottom: 24px;

      a:link,
      a:visited,
      a:hover,
      a:active {
        color: ${Colors.accent.grey1.standard};
        text-decoration: none;

        svg {
          position: relative;
          top: 2px;
        }
      }
    }
  }
  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .area-header {
      padding: 80px 0 70px 0;

      .hero-heading {
        font-size: 60px;
      }
    }
    .desktop-brands-columns {
      display: flex;
      justify-content: space-between;

      .desktop-brands-column {
        width: 48%;
      }
    }
    .desktop-brands-columns-subsidiaries {
      justify-content: flex-start;

      .desktop-brands-column {
        margin-right: 200px;
      }
    }
  }
`;

export default SubsidiariesStyles;
